export default __webpack_public_path__ + "static/media/nyydj.30c78358.png";